import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SignAuctionContract from "./SignHiringContract";
import { getAuctionById } from "../../../../redux/auction/action";
import ClientUserCommonDetails from "../../ClientUserCommonDetails";
import ContractView from "../../../CustomComponents/ContractView";

export default function HiringContract() {
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const pbi = useSelector(({ auction: { getauctionbyid } }) => getauctionbyid);

  useEffect(() => {
    dispatch(getAuctionById(id));
  }, [id]);


  const formatDateString = (dateString) => {
    const dateObj = new Date(dateString);
    const options = {
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return dateObj.toLocaleDateString("en-US", options);
  };
  const data = {
    mine: pbi?.user,
    user: Array.isArray(pbi?.winning_bid) && pbi?.winning_bid[0]?.user
  }
  return (
    <div className="container-fluid contract">
      <div className="project-offer project-details col-lg-10 mx-auto">
        <p className="breadcrumbs">
          <a onClick={() => navigate(-2)}>Home &gt; </a>
          <a onClick={() => navigate(-1)}>OTS details &gt;</a> Send offer
        </p>
        <div className="col-lg-10 mx-auto">
          <div className="contract-sec" id="capture-contract-section">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/contract-logo.svg`}
              alt=""
            />
            <div className="flex-sec">
              <p>Date : {formatDateString(pbi?.created_on)}</p>
              <p>ID : {pbi?.id}</p>
            </div>
            <div className="website-design">
              <ContractView type={'auction_agreement'} />
            </div>
            <ClientUserCommonDetails pbi={data} />
            <SignAuctionContract pbi={pbi} />
          </div>
        </div>
      </div>
    </div>
  );
}
